function titleCaseAddress(address = '') {
  return String(address)
    .toLowerCase()
    .replace(/(^|[\s-/'])([a-z])/g, (_, separator, letter) => separator + letter.toUpperCase());
}

export default titleCaseAddress;
